module.exports = __webpack_public_path__ + "img/placeholder.41803598.png";